class ChainFields {
  constructor(form) {
    form.dataset.chainInitialized = "true";
    this.form = form;

    this.init();
  }

  init() {
    const instance = this;
    this.form.querySelectorAll('[data-depend]').forEach((fieldWrap) => {
      const key = fieldWrap.dataset.depend;
      if (!key) {
        return;
      }

      const mainWrap = this.form.querySelector(`[data-chain-field="${key}"]`);
      if (mainWrap) {
        instance.bindPair(mainWrap, fieldWrap);
      }
    });
  }

  bindPair(mainWrap, dependWrap) {
    const mainSelect = mainWrap.querySelector('select');
    const key = mainWrap.dataset.chainField;
    if (!mainSelect) {
      return;
    }

    mainSelect.addEventListener('change', (e) => {
      const value = mainSelect.value;

      const groups = dependWrap.querySelectorAll('optgroup');
      groups.forEach((group) => {
        const groupKey = group.dataset[key];
        if (value === 'all' || value === groupKey) {
          group.disabled = '';
        } else {
          group.disabled = 'disabled';
        }
      });
    });
    mainSelect.dispatchEvent(new Event('change'));
  }
}

function initChainForms() {
  document.querySelectorAll('[data-chained-form]:not([data-chain-initialized="true"])')
    .forEach((form) =>  {
      new ChainFields(form)
    })
}

document.addEventListener('DOMContentLoaded', initChainForms);
document.addEventListener('DOMContentMutated', initChainForms);